import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMajorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			rx: 8,
			fill: "#B57025",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_30074_6153)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M11.7843 10.3333L8.67316 4.88886C8.60532 4.76916 8.50695 4.6696 8.38807 4.60033C8.2692 4.53106 8.13407 4.49457 7.99649 4.49457C7.85891 4.49457 7.72378 4.53106 7.60491 4.60033C7.48603 4.6696 7.38766 4.76916 7.31982 4.88886L4.20871 10.3333C4.14014 10.4521 4.10419 10.5868 4.10449 10.7239C4.1048 10.8611 4.14135 10.9957 4.21044 11.1141C4.27954 11.2326 4.37871 11.3306 4.49793 11.3984C4.61714 11.4662 4.75215 11.5012 4.88927 11.5H11.1115C11.248 11.4998 11.382 11.4638 11.5001 11.3955C11.6182 11.3271 11.7163 11.229 11.7845 11.1107C11.8526 10.9925 11.8885 10.8585 11.8885 10.722C11.8884 10.5855 11.8525 10.4515 11.7843 10.3333Z",
					stroke: "#B57025",
					strokeWidth: 1.06667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.00049 6.83337V8.38893",
					stroke: "#B57025",
					strokeWidth: 1.06667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.00049 9.94458H8.00413",
					stroke: "#B57025",
					strokeWidth: 1.06667,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_30074_6153",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 9.33333,
				height: 9.33333,
				fill: "white",
				transform: "translate(3.3335 3.33331)"
			})
		}) })
	]
});
export default SvgMajorIcon;
